import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';

export default styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? 'white' : theme.palette.grey[900],
}));
